import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "Giáo Dục",
  icon: "🧠",
  templates: [
    {
      title: "Giải Thích Đơn Giản",
      content: `Giải thích chủ đề [vắc-xin huấn luyện hệ miễn dịch như thế nào] một cách rõ ràng và hấp dẫn cho người nghe.
- Hãy tưởng tượng bạn đang giải thích cho [một thiếu niên tò mò không có kiến thức về khoa học].
- Sử dụng phép so sánh dễ hiểu: [so sánh với buổi diễn tập phòng cháy — bạn tập luyện để sẵn sàng khi tình huống thực xảy ra].
- Tránh thuật ngữ; khi cần dùng từ kỹ thuật, hãy định nghĩa ngay bằng ngôn ngữ đơn giản.
- Viết với giọng ấm áp, khuyến khích khiến người nghe cảm thấy thông minh, không bị coi thường.`
    },
    {
      title: "Lồng Tiếng Phim Tài Liệu",
      content: `Viết phần lồng tiếng theo phong cách phim tài liệu.
- Chủ đề: [cuộc sống hàng ngày của những người bán thức ăn đường phố ở Bangkok].
- Góc nhìn: [nghề thủ công, niềm tự hào và kiến thức truyền đời đằng sau những món ăn trông đơn giản nhưng mất nhiều năm để thành thạo].
- Giọng điệu: [tôn trọng, sống động và không vội vã — để các cảnh có không gian thở].
- Bao gồm chi tiết giác quan giúp người nghe hình dung và cảm nhận môi trường: [tiếng xèo xèo của chảo wok, độ ẩm của chợ sáng, những động tác tay chính xác của người bán đã làm điều này mười nghìn lần].
- Viết ở thì hiện tại để tạo cảm giác gần gũi.`
    },
    {
      title: "Thiền Có Hướng Dẫn",
      content: `Viết kịch bản thiền có hướng dẫn được thiết kế để nghe.
- Mục tiêu: [giải tỏa căng thẳng sau ngày làm việc dài và nhẹ nhàng bước vào buổi tối].
- Hướng dẫn người nghe hình dung [bờ hồ yên tĩnh lúc hoàng hôn — ánh sáng ấm trên mặt nước, làn gió nhẹ, tiếng chim xa đang đậu xuống cho đêm].
- Giọng điệu: [bình tĩnh, không vội vã và vững vàng].
- Thời lượng nói ước tính: [8 phút].
- Sử dụng nhiều khoảng dừng tự nhiên (đánh dấu bằng "...") giữa các hướng dẫn. Giữ câu ngắn và nhẹ nhàng. Tránh thay đổi năng lượng đột ngột.`
    }
  ]
};
